module.exports = __webpack_public_path__ + "a583d73f7ebfdb645bec333ef16e9c42.svg";